import React, { useLayoutEffect } from 'react';
import { rem } from 'design-system/values';
import { StatusBar, StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { IconSquareCircle } from 'design-system/icons';
import useColors from 'hooks/useColors';
import useColorScheme from 'hooks/useColorScheme';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useDefaultHeaderHeight } from 'hooks/useHeaderHeight';
import { AppView } from './AppView';
import { isWeb } from '../constants';
import Spacer from './Spacer';
/**
 * Figma: https://www.figma.com/file/SMqeFyVH6qLbMzeoCHBp4A/Emma-Design-System?node-id=4195%3A122415
 */
export const RequestActionView = ({ title, renderTitle, subTitle, icon, iconScale = 4.6, renderIcon, renderSubTitle, children, onDark, }) => {
    const colors = useColors();
    const iconNode = renderIcon?.();
    const navigation = useMainStackNavigation();
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const renderIconComponent = () => {
        if (iconNode)
            return iconNode;
        if (icon) {
            if (isWeb) {
                return (<View style={styles.iconContainer}>
            <View style={[
                        styles.iconContainerWeb,
                        {
                            backgroundColor: colors.cards.onLight,
                        },
                    ]}>
              {icon}
            </View>
          </View>);
            }
            // Mobile icon rendering with IconSquareCircle
            return (<View style={styles.iconContainer}>
          <IconSquareCircle color={onDark ? colors.cards.onDark : colors.cards.onLight} scale={iconScale}>
            {icon}
          </IconSquareCircle>
        </View>);
        }
        return null;
    };
    let subTitleContent;
    if (renderSubTitle) {
        subTitleContent = renderSubTitle();
    }
    else if (typeof subTitle === 'string') {
        subTitleContent = (<Text TextThin-16 centered Secondary>
        {subTitle}
      </Text>);
    }
    else {
        subTitleContent = subTitle;
    }
    let titleContent;
    if (renderTitle) {
        titleContent = renderTitle();
    }
    else if (typeof title === 'string') {
        titleContent = (<Text Text-24 OffBlack centered>
        {title}
      </Text>);
    }
    else {
        titleContent = title;
    }
    const content = (<>
      {renderIconComponent()}
      {isWeb ? <Spacer h={8}/> : null}
      <View>
        {titleContent ? (<View style={styles.titleContainer}>{titleContent}</View>) : (<Spacer h={16}/>)}
        {subTitleContent}
      </View>
    </>);
    const colorScheme = useColorScheme();
    const { paddingHorizontal } = useAppFrameDimensions(isWeb);
    const defaultHeaderHeight = useDefaultHeaderHeight();
    return (<>
      <StatusBar translucent animated backgroundColor="transparent" barStyle={colorScheme === 'dark' ? 'light-content' : 'dark-content'}/>
      <AppView type="secondary" style={[
            styles.content,
            {
                paddingHorizontal: (paddingHorizontal || 0) + rem(36),
                marginTop: -defaultHeaderHeight,
            },
        ]}>
        {content}
        {children}
      </AppView>
    </>);
};
const styles = StyleSheet.create({
    content: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: rem(36),
    },
    titleContainer: {
        marginBottom: rem(8),
        marginTop: rem(16),
    },
    iconContainer: {
        marginBottom: rem(18),
    },
    iconContainerWeb: {
        width: rem(100),
        height: rem(100),
        borderRadius: rem(50),
        justifyContent: 'center',
        alignItems: 'center',
    },
});
